"use client";

import React from "react";
import { ArrowRight, CircleCheck, Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ForgingProfessionals() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="105062" id="forjando-el-futuro-del-interior" className="dark bg-background text-foreground relative overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(var(--color-primary)_1px,transparent_1px)] [background-size:32px_32px] opacity-10" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-8 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col gap-6 transition-all duration-1000 ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-secondary/10 text-secondary w-fit text-sm font-bold border border-secondary/30 uppercase tracking-widest">
              <CircleCheck className="w-4 h-4" />
              <span>Líderes en el interior de Uruguay</span>
            </div>
            
            <h1 className="text-5xl lg:text-7xl xl:text-8xl font-black tracking-tighter text-white uppercase leading-[0.9]">
              FORJANDO EL FUTURO <span className="text-secondary">DEL INTERIOR</span>
            </h1>
            
            <p className="text-xl text-muted-foreground max-w-xl leading-relaxed font-medium">
              ECAP "Escuela de Capacitaciones Privadas" transforma tu vocación en una carrera profesional. Formación técnica de primer nivel con presencia en todo el país.
            </p>
            
            <div className="flex flex-wrap items-center gap-4 mt-4">
              <Button size="lg" asChild className="rounded-full px-8 h-14 text-base bg-secondary hover:bg-secondary/90 text-secondary-foreground font-bold shadow-lg shadow-secondary/20 animate-pulse">
                <Link to="https://wa.me/59896344395" newTab>
                  Consultar por WhatsApp <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
              <Button size="lg" variant="outline" asChild className="rounded-full px-8 h-14 text-base border-primary/50 text-primary-foreground hover:bg-primary/10 transition-colors">
                
              </Button>
            </div>
          </div>

          {}
          <div ref={imgRef} className={`relative lg:ml-auto w-full max-w-lg mx-auto transition-all duration-1000 delay-200 ${isImgVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            {}
            <div className="relative aspect-square md:aspect-[4/5] w-full">
              {}
              <div className="absolute inset-0 bg-primary/30 rounded-[30%_70%_70%_30%/30%_30%_70%_70%] blur-3xl animate-pulse" />
              
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/student_technical_lab_hero.png" alt="Técnico y estudiante de ECAP trabajando en laboratorio" className="absolute inset-0 w-full h-full object-cover rounded-[30%_70%_70%_30%/30%_30%_70%_70%] border-2 border-primary/50 shadow-2xl grayscale-[0.2] hover:grayscale-0 transition-all duration-500" />
            </div>

            {}
            <Card className="absolute -bottom-8 -left-4 md:-left-12 w-72 shadow-2xl border-white/10 bg-card/70 backdrop-blur-xl">
              <CardContent className="p-5 flex items-center gap-4">
                <div className="flex flex-col gap-1.5">
                  <div className="flex text-secondary">
                    {[...Array(5)].map((_, i) => <Star key={i} data-index={i} className="w-5 h-5 fill-current" />)}
                  </div>
                  <p className="font-black text-white text-xl leading-tight uppercase tracking-tight">
                    10+ Años de Éxito
                  </p>
                  <p className="text-sm text-muted-foreground font-medium">
                    Capacitaciones presenciales en cada rincón del país
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}